import React, { useState, useEffect, useRef } from 'react';
import { Spinner, Tab, Tabs } from 'react-bootstrap'
import { get } from '../../../utils/Storage';
import DeviceList from '../../Travel/Device/DeviceList';
import MarksList from '../../Travel/MarksList';
import MapTracker from '../MapTracker';

import './index.css'
function LocalizatorTabs({
  cod,
  travel,
  history,
  callbackDevices,
  loading,
  reportCallback,
  callbackModal }) {
  const [key, setKey] = useState('map');
  const [disableLog, setDisableLog] = useState(true);
  const localizatorAccess = useRef(true)
  const user = get('user')

  function logAccess() {
    setKey('log')
    setDisableLog(false)
  }

  useEffect(() => {
    setKey('map')
    setDisableLog(true)
  }, [cod])

  return (
    <div className="Tabs">
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="tabs-title"
      >
        <Tab eventKey="map" title="Mapa">
          {travel && <MapTracker localizatorCod={cod} travelDetails={travel} />}
        </Tab>
        <Tab eventKey="beacons" title="Dispositivos">
          {travel && <DeviceList
            travel={travel}
            callbackDevices={callbackDevices}
            logAccess={logAccess}
            reportCallback={reportCallback}
            callbackModal={callbackModal}
            user={user}
          />}
        </Tab>
        {user &&
          <Tab eventKey="log" title="Registros" disabled={disableLog}>
            {loading ?
              <div className="center-loading">
                <Spinner animation="border" />
              </div>
              :
              history && <MarksList
                data={history}
                localizatorAccess={localizatorAccess}
                reportCallback={reportCallback} />
            }
          </Tab>
        }
      </Tabs>
    </div>
  );
}

export default LocalizatorTabs;